// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"-name__-loca-__HuxZP","BreadTop":"-name__-loca-__10-cT","Seeds1":"-name__-loca-__3xHtz","Seeds2":"-name__-loca-__1cUso","Meat":"-name__-loca-__13nAN","Cheese":"-name__-loca-__1FxeY","Salad":"-name__-loca-__1iTJE","Bacon":"-name__-loca-__3vrAI"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BurgerIngredient/BurgerIngredient.css
// module id = 169
// module chunks = 0